import React, { useState, useRef, useImperativeHandle, forwardRef, useEffect } from 'react';
import { Text } from '@react-three/drei';



const Scoreboard = forwardRef(({ score, position = [0, 3.5, -23], rotation = [0.1, 0, 0] }, ref) => {
    const [displayString, setDisplayString] = useState('');
    const tempMessageTimer = useRef(null);
    const [isFlashing, setIsFlashing] = useState(false);

    useImperativeHandle(ref, () => ({
        showFlashMessage: (text, duration = 2000) => {
            if (tempMessageTimer.current) clearTimeout(tempMessageTimer.current);
            setDisplayString(text);
            setIsFlashing(true);
            tempMessageTimer.current = setTimeout(() => {
                setIsFlashing(false);
                tempMessageTimer.current = null;
            }, duration);
        }
    }));

    // Update display string when score changes, ONLY if not flashing
    useEffect(() => {
        if (!isFlashing) {
            // Format score with leading zeros (8 digits)
            setDisplayString(score.toString().padStart(8, '0'));
        }
    }, [score, isFlashing]);

    return (
        <group position={position} rotation={rotation}>
            {/* Outer Frame (Housing) - 30% Bigger */}
            <mesh position={[0, 0, -0.5]}>
                <boxGeometry args={[16, 5.5, 1.5]} />
                <meshStandardMaterial color="#0f172a" roughness={0.4} metalness={0.6} />
            </mesh>

            {/* Inner Frame Bevel */}
            <mesh position={[0, 0, 0.2]}>
                <boxGeometry args={[15.2, 4.7, 0.5]} />
                <meshStandardMaterial color="#334155" roughness={0.2} metalness={0.8} />
            </mesh>

            {/* Screen Background (Black) */}
            <mesh position={[0, 0, 0.5]}>
                <planeGeometry args={[14.5, 4]} />
                <meshBasicMaterial color="#000000" />
            </mesh>

            {/* DMD Text - Scaled Up */}
            <Text
                fontSize={2.0}
                color="#ffaa00" // Amber
                anchorX="center"
                anchorY="middle"
                position={[0, 0, 0.55]}
            >
                {displayString}
                <meshBasicMaterial color="#ffaa00" toneMapped={false} />
            </Text>
        </group>
    );
});

export default Scoreboard;
